var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeader',{attrs:{"title":"Sondages","description":"Gestion des sondages","button":{
      icon: 'fas fa-plus-circle',
      text: `Créer un sondage`,
      action: _vm.create
    }}}),_c('SurveysSubmenu'),_c('PageContent',[_c('MVPTable',{attrs:{"gridData":_vm.surveys,"options":_vm.gridOptions,"showAllDetails":false},on:{"rowDoubleClicked":_vm.goToSurvey}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }